import { useMemo } from 'react';
import { AppApiClient } from '../services/api';
import { useAppApi } from './useAppApi';
import { useAuthStore } from './useAuthStore';

export const useAuthenticatedAppApi = (): AppApiClient | null => {
    const appApiClient = useAppApi();
    const authStore = useAuthStore();
    return useMemo(() => (authStore.accessToken ? appApiClient.withToken(authStore.accessToken) : null), [appApiClient, authStore.accessToken]);
};
